export default __webpack_public_path__ + "static/media/4 1.66f2d922.svg";